const dicoRootNameTypes = {
    // Internal
    "1": "Capital",
    "2": "FixedAssets",
    "3": "Stocks",
    "4": "ThirdParty",
    "5": "Financial",
    "6": "Purchase",
    "7": "Sales",
    // VAT
    "8": "Special",
    S: "VAT",
};
const mandatoryAAName6s = [
    "600000",
    "700000",
    "512000",
    "589999",
    "471000",
    "401000",
    "411000",
    "421000",
    "425000",
    "164000",
];
const mandatoryAAName3s = [
    "701",
    "702",
    "703",
    "704",
    "705",
    "706",
    "707",
    "708",
    "709",
    //     "445",
    "511",
    //     // 3 de MONICA
    //     "408",
    //     "418",
    //     "428",
    //     "438",
    //     "448",
    //     "486",
    //     "487",
    //     "658",
    //     "758",
];
const mandatoryAAName4s = [
    "4456",
    "4457",
    //     // MONICA START
    //     "4098",
    //     "4198",
    //     "4282",
    //     "4286",
    //     "4382",
    //     "4386",
    //     "6311",
    //     "6333",
    //     "6334",
    //     "6335",
    //     "6411",
    //     "6412",
    //     "6413",
    //     "6414",
    //     "6415",
    //     "6458",
    //     "6811",
    //     // MONICA END
];
// const mandatoryAAName5s = [
//     // MONICA
//     "44551",
//     // "44566",
//     // "44567",
//     // "44562",
//     "44586",
//     "44587",
//     "63514",
//     "64145",
//     "68111",
//     "68112",
//     "68662",
//     "68665",
//     "68174",
//     "78174",
//     "68725",
//     "78725",
// ]

import generalAccountableAccountTable from "../assets/fec/generalAccountableAccountTable.json";

export type AccountableAccount = {
    id: string;
    type: string;
    name: string;
    // displayName: string
    description: string;
    // shortDescription: string
    lettering: boolean;
    detailedCarryForward: boolean;
    vatRate?: number;
    vatType?: string;
    vatOperationType?: string;
    user: boolean;
    bankAccount: boolean;
    thirdPartyCompany: boolean;
    tag: any;
};
export type AccountableAccountTable = {
    id: string;
    name: string;
    aaCharacterCount: number;
    accountableAccounts: AccountableAccount[];
};

export function filterAccountableAccounts(
    accountableAccountTable: AccountableAccountTable,
    includeRootAAs,
    excludeRootAAs = []
) {
    const output = [];
    if (!accountableAccountTable?.accountableAccounts?.length) {
        return [];
    }

    if (!includeRootAAs?.length && !excludeRootAAs?.length) {
        return accountableAccountTable.accountableAccounts;
    }

    for (const aa of accountableAccountTable.accountableAccounts) {
        // if (!withSubAccount && aa.subAccountableAccountOf) {
        //     continue
        // }
        const aaName = aa.name;
        if (aaName) {
            if (includeRootAAs) {
                if (includeRootAAs.find((raa) => raa && raa === aaName.substring(0, raa.length))) {
                    if (
                        !excludeRootAAs ||
                        !excludeRootAAs.find(
                            (raa) => raa && raa === aaName.substring(0, raa.length)
                        )
                    ) {
                        output.push(aa);
                    }
                }
            } else if (
                !excludeRootAAs ||
                !excludeRootAAs.find((raa) => raa && raa === aaName.substring(0, raa.length))
            ) {
                output.push(aa);
            }
        }
    }
    return output;
}

export function filterAccountableAccountsWithType(
    accountableAccountTable: AccountableAccountTable,
    type: string,
    excludeRootAAs
) {
    const output = [];
    if (!accountableAccountTable?.accountableAccounts?.length) {
        return [];
    }

    for (const aa of accountableAccountTable.accountableAccounts) {
        const aaName = aa.name;
        if (aa.name && aa.type) {
            if (aa.type === type) {
                if (
                    !excludeRootAAs ||
                    !excludeRootAAs.find((raa) => raa && raa === aaName.substring(0, raa.length))
                ) {
                    output.push(aa);
                }
            }
        }
    }
    return output;
}

export function filterAccountableAccountsWithTypes(
    accountableAccountTable: AccountableAccountTable,
    types: string[],
    excludeRootAAs
) {
    const output = [];
    if (!accountableAccountTable?.accountableAccounts?.length) {
        return [];
    }

    for (const aa of accountableAccountTable.accountableAccounts) {
        if (aa.name && aa.type) {
            if (types.find((type) => type && type === aa.type)) {
                if (
                    !excludeRootAAs ||
                    !excludeRootAAs.find((raa) => raa && raa === aa.name.substring(0, raa.length))
                ) {
                    output.push(aa);
                }
            }
        }
    }
    return output;
}

export function isMandatoryAccountbleAccount(aa) {
    if (!aa.name6) {
        debugger;
    } else if (mandatoryAAName6s.indexOf(aa.name6) !== -1) {
        return true;
    }

    if (!aa.name4) {
        debugger;
    } else if (mandatoryAAName4s.indexOf(aa.name4) !== -1) {
        return true;
    }

    if (!aa.name3) {
        debugger;
    } else if (mandatoryAAName3s.indexOf(aa.name3) !== -1) {
        return true;
    }
    return false;
}

export function isMandatoryAccountbleAccountFromName(aaName) {
    if (!aaName) {
        return;
    }
    if (aaName.length >= 6) {
        if (mandatoryAAName6s.indexOf(aaName.substring(0, 6)) !== -1) {
            return true;
        }
    }

    if (aaName.length >= 4) {
        if (mandatoryAAName4s.indexOf(aaName.substring(0, 4)) !== -1) {
            return true;
        }
    }

    if (aaName.length >= 3) {
        if (mandatoryAAName3s.indexOf(aaName.substring(0, 3)) !== -1) {
            return true;
        }
    }
    return false;
}

export function getMandatoryAccountableAccounts() {
    const maas = [...mandatoryAAName3s, ...mandatoryAAName4s, ...mandatoryAAName6s];
    return maas;
}

export function isGeneralAccountableAccount(accountableAccountName) {
    if (accountableAccountName) {
        let name = accountableAccountName;

        if (name.length > 6) {
            name = name.substring(0, 6);
            const suffix = accountableAccountName.substring(6);
            for (let index = 0; index < suffix.length; index++) {
                if (suffix[index] !== "0") {
                    return false;
                }
            }
        }
        return generalAccountableAccountTable[name];
    }
    return false;
}

export function getAccountableAccount(
    accountableAccountTable: AccountableAccountTable,
    name: string
) {
    if (!accountableAccountTable?.accountableAccounts?.length) {
        return undefined;
    }
    return accountableAccountTable.accountableAccounts.find((aa) => aa.name === name);
}

export function findAccountableAccount(
    accountableAccountTable: AccountableAccountTable,
    accountableAccount
) {
    if (!accountableAccountTable?.accountableAccounts?.length) {
        debugger;
        return undefined;
    }
    const aaName = accountableAccount.name.padEnd(accountableAccountTable.aaCharacterCount, "0");
    const description = accountableAccount.description?.toLowerCase() || "";
    return accountableAccountTable.accountableAccounts.find(
        (aa) => aa.name === aaName && aa.description?.toLowerCase() === description
    );
}

export function getRootName(name) {
    let rootName = name;
    while (rootName && rootName.endsWith("0")) {
        rootName = rootName.substring(0, rootName.length - 1);
    }
    return rootName;
}

export function computeAANames(name, data) {
    const count = name.length < 6 ? name.length : 6;
    for (let i = 1; i <= 6; i++) {
        data["name" + i] = name.substring(0, i);
    }
}

let defaultAccountableAccounts;

export async function getDefaultAccountableAccount(name): Promise<AccountableAccount> {
    if (!name) {
        debugger;
        return null;
    }
    await getDefaultAccountableAccounts();
    if (name.length > 6) {
        const aa = defaultAccountableAccounts[name.substring(0, 6)];
        if (aa) {
            return aa;
        }
    } else {
        const aa = defaultAccountableAccounts[name];
        if (aa) {
            return aa;
        }
    }
    let bankAccount = false;
    let description = "";
    if (name.startsWith("512")) {
        bankAccount = true;
        description = "Banques";
    }
    return {
        id: undefined,
        type: dicoRootNameTypes[name[0]],
        name,
        description,
        // displayName: undefined,
        // shortDescription: undefined,
        lettering: false,
        detailedCarryForward: false,
        user: false,
        bankAccount,
        thirdPartyCompany: false,
        tag: undefined,
    };
}

export async function getDefaultAccountableAccounts() {
    if (!defaultAccountableAccounts) {
        defaultAccountableAccounts = await import("./defaultAccountableAccounts.json");
        for (const aaKey in defaultAccountableAccounts) {
            const aa = defaultAccountableAccounts[aaKey];
            if (!aa.name) {
                continue;
            }
            aa.type = dicoRootNameTypes[aaKey[0]];
        }
    }
    return defaultAccountableAccounts;
}

export function getAccountableAccountType(aaName: string) {
    if (aaName) {
        return dicoRootNameTypes[aaName[0]];
    }
    debugger;
    return "";
}

// export function getVATRate(accountableAccount) {
//     if (accountableAccount.startsWith("4457") || accountableAccount.startsWith("7")) {
//         const key = accountableAccount.substring(4);
//         switch (key) {
//             case "00":
//                 return 0.0
//             case "02":
//                 return 2.1
//             case "05":
//                 return 5.5
//             case "08":
//                 return 8.5 // TAUX TVA 8.5
//             case "10":
//                 return 10
//             case "20":
//                 return 20
//             case "30":
//                 return 0
//             case "80":
//                 return 0
//         }
//         if (accountableAccount === "445600" ||
//             accountableAccount === "445662" ||
//             accountableAccount === "445200" ||
//             accountableAccount === "445630" ||
//             accountableAccount === "445680") {
//             return 0;
//         }
//     }
//     return undefined;
// }

// export function getVatRateSuffix(vatRate) {
//     switch (vatRate) {
//     case 0.0:
//         return ""
//     case 2.1:
//         return "02"
//     case 5.5:
//         return "05"
//     case 8.5:
//         return "08"
//     case 10:
//         return "10"
//     case 20:
//         return "20"
//     // case "30":
//     //     return 0
//     // case "80":
//     //     return 0
//     }
//     // debugger
//     return "";
// }
